export enum IntegrationType {
  EXCEL_AFFILIATE_SERVICE = 'ExcelAffiliateService',
  PROVIDER_TOKEN_SERVICE = 'ProviderTokenService',
}
  